// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"bd363c2b","480":"bed17193","723":"914ae71b"}[chunkId] + ".chunk.js";
};